import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
export function Loading(_a) {
    var title = _a.title;
    return (_jsxs(Box, { sx: { display: 'flex', justifyContent: 'center' }, children: [_jsx(CircularProgress, {}), " ", title] }));
}
